import { RecordManualPassageRequest } from '~/api/backend/pages/wellPageAPI'

interface PassageQueueItem {
  id: string
  request: RecordManualPassageRequest
  resolve: (value: void) => void
  reject: (error: unknown) => void
}

type RecordPassageFn = (request: RecordManualPassageRequest) => Promise<void>

export class PassageQueue {
  private queue: PassageQueueItem[] = []
  private processing = false
  private delayMs = 300 // Delay between requests

  async enqueue(
    request: RecordManualPassageRequest,
    recordPassageFn: RecordPassageFn,
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      const id = `${request.parent_plate_name}_${request.child_plate_name}_${Date.now()}`

      this.queue.push({
        id,
        request,
        resolve,
        reject,
      })

      console.log(`Enqueued passage: ${id}`)

      if (!this.processing) {
        this.processQueue(recordPassageFn)
      }
    })
  }

  private async processQueue(recordPassageFn: RecordPassageFn) {
    this.processing = true

    while (this.queue.length > 0) {
      const item = this.queue.shift()!

      try {
        // Use the provided function to make the request
        await recordPassageFn(item.request)

        item.resolve(undefined)
      } catch (error) {
        console.error(`Failed to process passage ${item.id}:`, error)
        item.reject(error)
      }

      // Small delay between requests to avoid overwhelming the backend
      if (this.queue.length > 0) {
        await new Promise(resolve => setTimeout(resolve, this.delayMs))
      }
    }

    this.processing = false
  }

  // Get current queue status for debugging
  getQueueStatus() {
    return {
      queueLength: this.queue.length,
      processing: this.processing,
      delayMs: this.delayMs,
    }
  }
}

// Export singleton instance
export const passageQueue = new PassageQueue()
